exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table td[data-v-3ebb6f0e], .table th[data-v-3ebb6f0e] {\n    padding: 0rem;\n    vertical-align: top;\n    border-top: 1px solid #dee2e6;\n}\n", ""]);

// exports
